import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import { ScrollArea } from "@/components/ui/scroll-area";
import { History, ArrowRight } from "lucide-react";

const ACTION_COLORS = {
  created: "text-slate-600",
  submitted: "text-blue-700",
  manager_reviewed: "text-amber-700",
  accountant_approved: "text-emerald-700",
  locked: "text-indigo-900",
  reopened: "text-rose-700",
  adjustment_requested: "text-amber-700",
  adjustment_approved: "text-emerald-700",
  adjustment_rejected: "text-rose-700",
};

function fmt(ts) {
  if (!ts) return "";
  try {
    return new Date(ts).toLocaleString("en-KE", { dateStyle: "medium", timeStyle: "short" });
  } catch {
    return ts;
  }
}

export default function AuditTrailDrawer({ open, onOpenChange, logs }) {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent className="w-full overflow-hidden sm:max-w-md" data-testid="audit-trail-drawer">
        <SheetHeader>
          <SheetTitle className="flex items-center gap-2 font-display">
            <History className="h-5 w-5" /> Audit Trail
          </SheetTitle>
        </SheetHeader>
        <ScrollArea className="mt-4 h-[calc(100vh-6rem)] pr-3">
          <ol className="relative space-y-4 border-l border-slate-200 pl-5">
            {(logs || []).length === 0 && (
              <li className="text-sm text-muted-foreground">No audit entries yet.</li>
            )}
            {(logs || []).map((log, i) => (
              <li key={log._id || i} className="relative" data-testid={`audit-entry-${i}`}>
                <span className="absolute -left-[1.42rem] top-1 h-2.5 w-2.5 rounded-full border-2 border-white bg-brand" />
                <div className={`text-sm font-semibold capitalize ${ACTION_COLORS[log.action] || "text-slate-800"}`}>
                  {log.action.replace(/_/g, " ")}
                </div>
                {log.field && (
                  <div className="mt-1 flex items-center gap-2 rounded-md bg-slate-50 px-2 py-1 text-xs">
                    <span className="font-medium text-slate-600">{log.field}</span>
                    <span className="font-mono-fin text-rose-600 line-through">{String(log.before ?? "—")}</span>
                    <ArrowRight className="h-3 w-3 text-slate-400" />
                    <span className="font-mono-fin text-emerald-700">{String(log.after ?? "—")}</span>
                  </div>
                )}
                {log.reason && <div className="mt-1 text-xs italic text-slate-600">"{log.reason}"</div>}
                <div className="mt-1 text-[11px] text-muted-foreground">
                  {log.actor} · {fmt(log.timestamp)}
                </div>
              </li>
            ))}
          </ol>
        </ScrollArea>
      </SheetContent>
    </Sheet>
  );
}
